import * as firebase from 'firebase'

// Exams Module

const state = {
  userExams: [],
};

const mutations = {
  // Set User Exams on Login
  setUserExams(state, payload) {
    state.userExams = payload
  },
  // Add User Exam
  addExamInfo(state, payload) {
    state.userExams.push(payload)
  },
  // Edit User Exam
  setEditExam(state, payload) {

  },
  // Remove User Exam
  removeUserExam(state, payload) {
    state.userExams.forEach(exam => {
      if(exam.id === payload) {
        state.userExams.splice(state.userExams.indexOf(exam), 1)
      }
    })
  },
  // Add Exam Scores
  addExamScores(state, payload) {
   const exam = state.userExams.find(exam => {
      return exam.id === payload.id
    })
    if(exam.exam_type === 'GRE') {
      exam.exam_scores = true,
      exam.gre_combined_score = payload.gre_combined_score,
      exam.gre_verbal_reasoning_score = payload.gre_verbal_reasoning_score,
      exam.gre_analytical_writing_score = payload.gre_analytical_writing_score,
      exam.gre_quantitative_reasoning_score  = payload.gre_quantitative_reasoning_score,
      exam.gre_verbal_percentile_score = payload.gre_verbal_percentile_score,
      exam.gre_quantitative_percentile_score = payload.gre_quantitative_percentile_score,
      exam.gre_analytical_percentile_score = payload.gre_analytical_percentile_score
    }

    if(exam.exam_type === 'MCAT') {
      exam.exam_scores = true,
      exam.mcat_total_score = payload.mcat_total_score
    }

    if(exam.exam_type === 'TOEFL iBT') {
      exam.exam_scores = true,
      exam.mcat_total_score = payload.mcat_total_score
      exam.toeflIbt_total_score = payload.toeflIbt_total_score,
      exam.toeflIbt_reading_score = payload.toeflIbt_reading_score,
      exam.toeflIbt_listening_score = payload.toeflIbt_listening_score,
      exam.toeflIbt_speaking_score = payload.toeflIbt_speaking_score,
      exam.toeflIbt_writing_score = payload.toeflIbt_writing_score
    }

    if(exam.exam_type === 'TOEFL PBT') {
      exam.exam_scores = true,
      exam.toeflPbt_total_score = payload.toeflPbt_total_score,
      exam.toeflPbt_reading_score = payload.toeflPbt_reading_score,
      exam.toeflPbt_writing_score = payload.toeflPbt_writing_score,
      exam.toeflPbt_listening_score = payload.toeflPbt_listening_score
    }
    if(exam.exam_type === 'PTE Academic') {
      exam.exam_scores = true,
      exam.pteAcademic_overall_score = payload.pteAcademic_overall_score
    }
    if(exam.exam_type === 'IELTS') {
      exam.exam_scores = true,
      exam.ielts_overall_score = payload.ielts_overall_score
    }

    if(exam.exam_type === 'MELAB') {
      exam.exam_scores = true,
      exam.melab_overall_score = payload.melab_overall_score
    }

    if(exam.exam_type === 'iTEP Academic') {
      exam.exam_scores = true,
      exam.itepAcademic_overall_score = payload.itepAcademic_overall_score
    }
    console.log(state.userExams)

  },
   // Logout Colleges
   setLogoutUser(state, payload = null) {
    state.userExams = []

  },
};

const actions = {
   // Add User Exam
   setAddExam({commit, getters, dispatch}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/exams/').push(payload)
    .then((data) => {
      const key = data.key
      commit('addExamInfo', {
        ...payload,
        id:key,
      })
      dispatch('setupUserData', firebase.auth().currentUser, { root: true })
    })
  },
  // Edit User Exam
  setEditExam({commit, getters}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/exams/' + payload.examId).update(payload)
    .then((data) => {
      dispatch('setupUserData', firebase.auth().currentUser, { root: true })
    })
  },
  // Update Exam Status
  setUpdateExamStatus({commit, getters, dispatch}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/exams/' + payload.examId).update({examStatus: payload.examStatus})
    .then((data) =>{
      dispatch('setupUserData', firebase.auth().currentUser, { root: true })
    })
  },
  // Update Exam Date
  setUpdateExamDate({commit, getters, dispatch}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/exams/' + payload.examId).update({date: payload.date})
    .then((data) =>{
      dispatch('setupUserData', firebase.auth().currentUser, { root: true })
    })
  },
  // Add Exam Scores
  setAddExamScores({commit, getters, dispatch}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/exams/' + payload.id).update(payload)
    .then((data) =>{
      commit('addExamScores', payload)
      dispatch('setupUserData', firebase.auth().currentUser, { root: true })
    })

  },
  // Remove User Exam
  setRemoveExam({commit, getters, dispatch}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/exams/').child(payload).remove()
    .then((data) => {
      commit('removeUserExam', payload)
      dispatch('setupUserData', firebase.auth().currentUser, { root: true })
    })
  },
};


const getters = {
  // User Exams List
  userExams(state) {
    return state.userExams
  },
  // User Exam Info
  examInfo(state) {
    return (id) => {
      return state.userExams.find((exam) => {
        return exam.id === id
      })
    }
  }
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/exams.js